module.exports = __webpack_public_path__ + "static/media/salty-seadog-illustration.0589a71c.jpg";